export default {
  alerts: [],
  flashes: [],
};
